import axios from "axios";
import { OnlineServicesV1 } from "../onlinedienste/OnlineServicesV1";
import { isRuntimeDev } from "../../../common/utils/environmentUtils";

export const FORMULAR_PROD_URL = "https://fastforms.de/cirali/cfs/formlist?mandantid=323&purexml=yes&json=true";
export const FORMULAR_DEV_URL = `https://www.startgebiet.de//cirali/cfs/formlist?mandantid=289&purexml=yes&json=1`;
export const FORMULAR_URL = isRuntimeDev ? FORMULAR_DEV_URL : FORMULAR_PROD_URL;

export const fetchFormulars = () => axios.get<OnlineServicesV1[]>(FORMULAR_URL).then((response) => response.data);
